<div class="container noMaxWidth bottom-tab-container d-lg-none" [class.dropShadow]="showDropShadow"
  [class.mat-app-background]="useMaterialTheme" [class.cfaCustomLightTheme]="!useMaterialTheme">
  <div class="row justify-content-center cfa-toolbar-height">
    @if (cfaTabs.length === 1) {
      <div class="col-2 align-self-center pr-0 pl-0">
      </div>
    }
    @for (tab of cfaTabs; track tab; let i = $index) {
      <div
        class="col cfa-toolbar-height cfa-bottom-nav clicky"
        [class.active]="tab.active"
        [class.disabled]="tab.disabled"
        (click)="clickTab($event, tab)" id="tab{{i}}">
        <svg-icon src="{{tab.getIconUrl()}}" class="cfa-bottom-nav-icon cfa-icon"></svg-icon>
        <div class="cfa-11 cfa-bottom-nav-label">{{tab.label}}</div>
        @if (tab.childTabs && tab.childTabs.length > 0 && tab.expanded) {
          <div class="child-tab-container-bottom"
            [@openOverlayState]="'active'"
            [class.mat-app-background]="useMaterialTheme"
            [class.cfaCustomLightTheme]="!useMaterialTheme">
            @for (cTab of tab.childTabs; track cTab; let j = $index; let last = $last) {
              <div class="row cfa-child-nav-tab cfa-toolbar-height"
                [class.active]="cTab.active"
                [class.disabled]="tab.disabled || cTab.disabled"
                (click)="clickTab($event, cTab)" id="cTab{{j}}">
                <div class="col-12 align-self-center cfa-15 text-center">
                  {{cTab.label}}
                </div>
              </div>
              @if (!last) {
                <hr class="child-tab-separator">
              }
            }
          </div>
        }
      </div>
    }
    <div class="col-2 cfa-toolbar-height pl-0" (click)="clickMenu()">
      <svg-icon src="https://d4gii57lvoht3.cloudfront.net/images/Three_Dot_Vert.svg" class="cfa-bottom-menu-icon"></svg-icon>
    </div>
    @if (expandMenu) {
      <div class="cfa-mobile-menu d-block d-lg-none" [@openOverlayState]="'active'"
        [class.mat-app-background]="useMaterialTheme" [class.cfaCustomLightTheme]="!useMaterialTheme">
        <div class="container pt-2 pb-2">
          @for (menuItem of cfaMenuItems; track menuItem; let i = $index) {
            <div class="row pt-2 pb-2" (click)="selectMenuItem(menuItem)">
              <div class="col" [class.cfa-14]="menuItem.textOnly" [class.cfa-18]="!menuItem.textOnly"
                [class.clicky]="!menuItem.textOnly" [class.disabled]="menuItem.disabled">
                {{menuItem.label}}
              </div>
            </div>
          }
          @if (cfaMenuItems.length > 0 && userName) {
            <hr>
            }
            @if (userName) {
              <div class="row pt-2 pb-2">
                <div class="col cfa-14">
                  {{userName}}
                </div>
              </div>
            }
            @if (userName) {
              <div class="row pt-2 pb-2">
                <div class="col cfa-18 clicky cfa-primary" (click)="clickSignOut()">
                  Sign Out
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
